import { accessServiceApiSlice } from "state/services/accessServiceApiSlice";

export const accessServiceApiMutations = accessServiceApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // POST /role-assignments
    createRoleAssignment: builder.mutation({
      query: (body) => ({
        url: "/role-assignments",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "RoleAssignment", id: "LIST" }, "EffectiveAccess"],
    }),

    // PUT /role-assignments — always an array, even for a single record.
    // Response: { updated: [{ role_assignment, message }], not_updated: [{ role_assignment, message }] }
    updateRoleAssignments: builder.mutation({
      query: (assignments) => ({
        url: "/role-assignments",
        method: "PUT",
        body: Array.isArray(assignments) ? assignments : [assignments],
      }),
      transformResponse: (responseData) => ({
        updated: responseData?.updated || [],
        not_updated: responseData?.not_updated || [],
      }),
      invalidatesTags: (result, error, arg) => {
        const ids = (Array.isArray(arg) ? arg : [arg]).map((a) => ({
          type: "RoleAssignment",
          id: a.id,
        }));
        return [...ids, { type: "RoleAssignment", id: "LIST" }, "EffectiveAccess"];
      },
    }),

    // DELETE /role-assignments/{id}
    deleteRoleAssignment: builder.mutation({
      query: (id) => ({
        url: `/role-assignments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "RoleAssignment", id },
        { type: "RoleAssignment", id: "LIST" },
        "EffectiveAccess",
      ],
    }),

    // POST /roles
    createRole: builder.mutation({
      query: (body) => ({
        url: "/roles",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Role", id: "LIST" }],
    }),

    // DELETE /roles/{id}
    deleteRole: builder.mutation({
      query: (id) => ({
        url: `/roles/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Role", id }, { type: "Role", id: "LIST" }],
    }),

    // PUT /roles — always an array.
    updateRoles: builder.mutation({
      query: (roles) => ({
        url: "/roles",
        method: "PUT",
        body: Array.isArray(roles) ? roles : [roles],
      }),
      transformResponse: (responseData) => ({
        updated: responseData?.updated || [],
        not_updated: responseData?.not_updated || [],
      }),
      invalidatesTags: (result, error, arg) => {
        const ids = (Array.isArray(arg) ? arg : [arg]).map((r) => ({ type: "Role", id: r.id }));
        return [...ids, { type: "Role", id: "LIST" }];
      },
    }),
  }),
});

export const {
  useCreateRoleAssignmentMutation,
  useUpdateRoleAssignmentsMutation,
  useDeleteRoleAssignmentMutation,
  useCreateRoleMutation,
  useDeleteRoleMutation,
  useUpdateRolesMutation,
} = accessServiceApiMutations;
